import { EVENT_STATUS } from "./eventConstants";

/**
 * Resolves event status from API response fields.
 */
export const resolveEventStatus = (item) => {
  if (!item) return EVENT_STATUS.DRAFT;

  const raw =
    item.status ??
    item.Status ??
    item.eventStatus ??
    item.EventStatus ??
    "";

  const normalized = String(raw).trim();

  if (normalized === EVENT_STATUS.ACTIVE || normalized === "Published") {
    return EVENT_STATUS.ACTIVE;
  }

  if (
    normalized === EVENT_STATUS.INACTIVE ||
    normalized === "Unpublished" ||
    normalized === "Inactive"
  ) {
    return EVENT_STATUS.INACTIVE;
  }

  if (normalized === EVENT_STATUS.DRAFT) {
    return EVENT_STATUS.DRAFT;
  }

  return EVENT_STATUS.DRAFT;
};

export const renderEventStatusBadge = (status) => {
  const label = resolveEventStatus({ status });
  let tone = "secondary";
  if (label === EVENT_STATUS.ACTIVE) tone = "success";
  else if (label === EVENT_STATUS.DRAFT) tone = "warning";

  return <span className={`badge badge-soft-${tone}`}>{label}</span>;
};

/**
 * UI-only "expired" check for the Manage Events listing — does not touch the
 * API, database status, or resolveEventStatus. An event is expired once
 * eventsTo falls before today's date (date-only comparison).
 */
export const isEventExpired = (item) => {
  const rawEventsTo = item?.eventsTo;
  if (!rawEventsTo) return false;

  const eventsToDate = new Date(rawEventsTo);
  if (Number.isNaN(eventsToDate.getTime())) return false;
  eventsToDate.setHours(0, 0, 0, 0);

  const today = new Date();
  today.setHours(0, 0, 0, 0);

  return eventsToDate < today;
};

/**
 * Status badge for a listing row. Expired takes priority over the API status
 * (e.g. an Active event whose eventsTo has passed still shows as Expired) —
 * purely visual, the underlying status value is never changed.
 */
export const renderEventStatusBadgeForItem = (item) => {
  if (isEventExpired(item)) {
    return (
      <span
        className="badge badge-soft-danger"
        title="This event has already ended."
      >
        <i className="ri-error-warning-line me-1" aria-hidden="true"></i>
        Expired
      </span>
    );
  }

  return renderEventStatusBadge(item?.status);
};
